import React from 'react';
import { RouteComponentProps } from 'react-router';
import { isoToDateLocal, startOfDayLocal } from '../../../shared/lib/time';
import Page from '../../pages/Page';
import { DatePicker, Schedule, Sailings } from '../components';
import { DatePickerMode } from '../components/DatePicker';

export interface MainPageState {
  selectedDate: Date;
  startDate: Date;
  view: 'schedule' | 'sailings';
  datePickerMode: DatePickerMode;
}

export interface MainPageParams {
  staff: string;
  date?: string;
}

export type MainPagePageProps = RouteComponentProps<MainPageParams>;

export default class MainPage extends React.Component<MainPagePageProps, MainPageState> {
  public readonly state: MainPageState;

  private staffTemplateId: string;

  constructor(props: MainPagePageProps) {
    super(props);

    this.staffTemplateId = this.props.match.params.staff;

    let currentDate = this.props.match.params.date
      ? isoToDateLocal(this.props.match.params.date)
      : startOfDayLocal();

    this.state = {
      selectedDate: currentDate,
      startDate: currentDate,
      view: 'schedule',
      datePickerMode: 'day',
    };
  }

  public render() {
    return (
      <Page className="CrewMainPage absolute flex flex-col h-full">
        {this.state.view === 'schedule' ? (
          <Schedule
            history={this.props.history}
            staffId={this.props.match.params.staff}
            staffTemplateId={this.staffTemplateId}
            date={this.state.selectedDate}
          />
        ) : (
          <Sailings
            staffTemplateId={this.staffTemplateId}
            date={this.state.selectedDate}
            onHomeButtonClick={this.handleSailingsHomeButtonClick}
          />
        )}
        <DatePicker
          mode={this.state.datePickerMode}
          startDate={this.state.startDate}
          selectedDate={this.state.selectedDate}
          onSelectedDateChange={this.handleSelectedDateChange}
          onStartDateChange={this.handleStartDateChange}
          onSailingsButtonClick={this.handleSailingsButtonClick}
          onModeChange={this.handleDatePickerModeChange}
        />
      </Page>
    );
  }

  private handleSailingsHomeButtonClick = () => {
    this.setState({ view: 'schedule' });
  };

  private handleSelectedDateChange = (date: Date) => {
    this.setState({ selectedDate: date });
  };

  private handleStartDateChange = (date: Date) => {
    this.setState({ startDate: date });
  };

  private handleDatePickerModeChange = (newMode: DatePickerMode) => {
    this.setState({ datePickerMode: newMode });
  };

  private handleSailingsButtonClick = () => {
    this.setState({ view: 'sailings', datePickerMode: 'day' });
  };
}
